// Author: Mohammad Arman Khan

import React, { Component } from 'react';
import Header from '../../layout/header/header'
import Footer from '../../layout/footer/footer'
import acser from '../../assets/ac-ser.png'

import '../order/order.css';

class order extends Component {
    render() {
        return (
            <div>
    <Header/>

    <div className="my_order">
        <div className="container-fluid">
            <div className="order_inr_main">
                <h2>Today</h2>
                <div className="today_order">
                    <div className="table-responsive">
                        <table className="table">
                            <tbody>
                                <tr>
                                  <td><div className="order_img"><img className="img-fluid" src={acser} alt="" /></div></td>
                                  <td>
                                    <div className="order_img">
                                      <h3>AC repair</h3>
                                      <h4>Split Ac repair</h4>
                                      <p>Order placed at 12:00 AM on 12/9/21</p>
                                    </div>
                                  </td>
                                  
                                  <td>
                                    <div className="order_track">
                                    <h3><button type="button" class="btn btn-primary" data-toggle="modal" data-target="#Openm">
                                      Track your professional
                                        </button>
                                        </h3>
                                      <h4>AED 55</h4>
                                    </div>
                                  </td>


                                  <td>
                                    <div className="reschedule">
                                    <h3><button type="button" class="btn btn-primary" data-toggle="modal" data-target="#RESCHEDULE">
                                          RESCHEDULE
                                          </button>
                                          </h3>
                                  <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#upgrade">
                                           upgrade Order
                                      </button>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="cancelorder">
                                    <h3><button type="button" class="btn btn-primary" data-toggle="modal" data-target="#CANCEL">
      CANCEL
    </button></h3>
                                      <button>Call</button>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="writereview">
                                      <h3>Write a review</h3>
                                      <div className="input_dgn">
                                        <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                        <button>Submit</button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <h2>This Month</h2>
                <div className="this_month_order">
                    <div className="table-responsive">
                      <table className="table">
                        <tbody>
                            <tr>
                              <td><div className="order_img"><img className="img-fluid" src={acser} alt="" /></div></td>
                              <td>
                                <div className="order_img">
                                  <h3>AC repair</h3>
                                  <h4>Split Ac repair</h4>
                                  <p>Order placed at 12:00 AM on 12/9/21</p>
                                </div>
                              </td>
                              
                              <td>
                                <div className="order_track">
                                  <h3>Track your Professional</h3>
                                  <h4>AED 55</h4>
                                </div>
                              </td>


                              <td>
                                <div className="reschedule">
                                  <h3>Reschedule order</h3>
                                  <button>Upgrade order</button>
                                </div>
                              </td>

                              <td>
                                <div className="cancelorder">
                                  <h3>Cancel</h3>
                                  <button>Call</button>
                                </div>
                              </td>

                              <td>
                                <div className="writereview">
                                  <h3>Write a review</h3>
                                  <div className="input_dgn">
                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                    <button>Submit</button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div className="this_month_order">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                          <tr>
                            <td><div className="order_img"><img className="img-fluid" src={acser} alt="" /></div></td>
                            <td>
                              <div className="order_img">
                                <h3>AC repair</h3>
                                <h4>Split Ac repair</h4>
                                <p>Order placed at 12:00 AM on 12/9/21</p>
                              </div>
                            </td>
                            
                            <td>
                              <div className="order_track">
                                <h3>Track your Professional</h3>
                                <h4>AED 55</h4>
                              </div>
                            </td>


                            <td>
                              <div className="reschedule">
                                <h3>Reschedule order</h3>
                                <button>Upgrade order</button>
                              </div>
                            </td>

                            <td>
                              <div className="cancelorder">
                                <h3>Cancel</h3>
                                <button>Call</button>
                              </div>
                            </td>

                            <td>
                              <div className="writereview">
                                <h3>Write a review</h3>
                                <div className="input_dgn">
                                  <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                  <button>Submit</button>
                                </div>
                              </div>
                            </td>
                          </tr>
                      </tbody>
                  </table>
                  </div>
                </div>
                <div className="this_month_order">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                          <tr>
                            <td><div className="order_img"><img className="img-fluid" src={acser} alt="" /></div></td>
                            <td>
                              <div className="order_img">
                                <h3>AC repair</h3>
                                <h4>Split Ac repair</h4>
                                <p>Order placed at 12:00 AM on 12/9/21</p>
                              </div>
                            </td>
                            
                            <td>
                              <div className="order_track">
                                <h3>Track your Professional</h3>
                                <h4>AED 55</h4>
                              </div>
                            </td>


                            <td>
                              <div className="reschedule">
                                <h3>Reschedule order</h3>
                                <button>Upgrade order</button>
                              </div>
                            </td>

                            <td>
                              <div className="cancelorder">
                                <h3>Cancel</h3>
                                <button>Call</button>
                              </div>
                            </td>

                            <td>
                              <div className="writereview">
                                <h3>Write a review</h3>
                                <div className="input_dgn">
                                  <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                  <button>Submit</button>
                                </div>
                              </div>
                            </td>
                          </tr>
                      </tbody>
                  </table>
                  </div>
                </div>
                <div className="this_month_order">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                          <tr>
                            <td><div className="order_img"><img className="img-fluid" src={acser} alt="" /></div></td>
                            <td>
                              <div className="order_img">
                                <h3>AC repair</h3>
                                <h4>Split Ac repair</h4>
                                <p>Order placed at 12:00 AM on 12/9/21</p>
                              </div>
                            </td>
                            
                            <td>
                              <div className="order_track">
                                <h3>Track your Professional</h3>
                                <h4>AED 55</h4>
                              </div>
                            </td>


                            <td>
                              <div className="reschedule">
                                <h3>Reschedule order</h3>
                                <button>Upgrade order</button>
                              </div>
                            </td>

                            <td>
                              <div className="cancelorder">
                                <h3>Cancel</h3>
                                <button>Call</button>
                              </div>
                            </td>

                            <td>
                              <div className="writereview">
                                <h3>Write a review</h3>
                                <div className="input_dgn">
                                  <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                  <button>Submit</button>
                                </div>
                              </div>
                            </td>
                          </tr>
                      </tbody>
                  </table>
                  </div>
                </div>
              
            </div>
        </div>

    </div>
    <Footer/>
    <div class="modal" id="Openm">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
         <h3>rechedule Your current Order to</h3>
         <div class="row justify-content-between align-items-center">
          <label for="date">Date</label>
          <input type="text" name="date"/>
         </div>
         <div class="row justify-content-between align-items-center">
         <label for="date">Time</label>
         <input type="text" name="time"/>
         </div>
         <div class="row justify-content-center">
         <span>aditional charges may be applicable *</span>
         </div>
         <div class="row justify-content-center"><button>Book</button></div>
         
        </div>
      </div>
    </div>
  </div>
  {/*  */}

  <div class="modal" id="RESCHEDULE">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
           <h3>Reschedule Order</h3>
           <div class="row justify-content-between align-items-center">
            <label for="date">Date</label>
            <input type="text" name="date"/>
            </div>
            <div class="row justify-content-between align-items-center">
            <label for="date">Time</label>
            <input type="text" name="time"/>
            </div>
            <div class="row justify-content-center"><button>Reschedule</button></div>
          </div>
        </div>
      </div>
    </div>

    {/*  */}

    <div class="modal" id="CANCEL">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
           <h3>Order Id AXE347 for 12th jan 2021 will be cancled?</h3>
           <div class="cencle_btn">
           <button>Yes Do it </button>
           <button class="nooo">No</button>
           </div>
           
           <span>cancellation policy</span>
          </div>
        </div>
      </div>
    </div>
    {/*  */}

    <div class="modal" id="upgrade">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
           <h2>upgrade Order</h2>
           <div class="upgrade_btn">
           <button>View Subscriptions </button>
           <button>visit Store</button>
           </div>
          </div>
        </div>
      </div>
    </div>
            </div>
        );
    }
}

export default order;
